import { BaseEntity } from '@app/models';
import { ApprovalUserModel } from './approval-user.model';

export class ApprovalLevelModel extends BaseEntity {
	Description: string;
	ApprovalTypeId: number;
	Final: boolean;
	Ordinal: number;
	ApprovalUsers: ApprovalUserModel[];
	UsedOnPurchaseOrder: boolean;
}
